var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckplusLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 381.113,
    height: 92.38,
    viewBox: "0 0 381.113 92.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.391,
    y1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c77b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61bbf9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340",
    transform: "translate(-526.317 -331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(478.867 -715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(47.45 1055.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset_2",
    "data-name": "Asset 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M34.3,69.854a1.429,1.429,0,0,1-2.029,0L.417,38.029A1.429,1.429,0,0,1,.417,36L36,.417a1.429,1.429,0,0,1,2.029,0L69.854,32.241a1.429,1.429,0,0,1,0,2.029l-5.545,5.487a1.429,1.429,0,0,1-2.029,0L37.986,15.465a1.429,1.429,0,0,0-2.029,0L15.465,36a1.429,1.429,0,0,0,0,2.029L39.758,62.323a1.429,1.429,0,0,1,0,2.029Z",
    transform: "translate(0.006 0.006)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M55.278,69.852a1.429,1.429,0,0,1-2.029,0L21.467,38.027a1.429,1.429,0,0,1,0-2.029l5.5-5.5A1.429,1.429,0,0,1,29,30.5L53.292,54.79a1.429,1.429,0,0,0,2.029,0L75.856,34.3a1.429,1.429,0,0,0,0-2.015L51.562,7.989a1.429,1.429,0,0,1,0-2.015l5.5-5.559a1.429,1.429,0,0,1,2.015,0L90.9,32.239a1.429,1.429,0,0,1,0,2.015Z",
    transform: "translate(9.037 0.008)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    transform: "translate(164.944 1046)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CheckPlus",
    transform: "translate(0 48)",
    fill: "#2b91d6",
    fontSize: 49,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CheckPlus")), /*#__PURE__*/React.createElement("text", {
    id: "for_Nonprofits_\\u975E\\u725F\\u5229\\u7248",
    "data-name": "for Nonprofits \\u975E\\u725F\\u5229\\u7248",
    transform: "translate(2.62 83.38)",
    fill: "#2b91d6",
    fontSize: 25,
    fontFamily: "HelveticaNeue, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "for Nonprofits "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "PingFangSC-Regular, PingFang SC"
  }, "\u975E\u725F\u5229\u7248")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckplusLogo);
export default __webpack_public_path__ + "static/media/checkplus-logo.144f5bcd26e966ddf37a9608efa46ac0.svg";
export { ForwardRef as ReactComponent };